export default function formattedLikesCount(count) {
	return count > 99 ? "99+" : count;
}



// WEBPACK FOOTER //
// ./src/shared/util/formattedLikesCount.js